import React, { useEffect, useState, useContext } from "react";
import { useParams } from 'react-router';
import { Box } from "@mui/system";
import { useTheme } from "@mui/material";
import { Ico_Correct, Ico_Timed, Title, PillTabs, PillTab, AuthContext, IUser } from "@sagecentral/core-ui";
import ProjectTaskGrid from "../tasks/ProjectTaskGrid";
import ProjectsOverview from "../projects-overview";
import { ProjectContext } from "../project-layout";
import { useCurrentUser } from "hooks/shared";
import { TaskFocus } from "models/work-items/IWorkItemTask";

const OverviewTasks = () => {
    const auth = useContext(AuthContext);
    const project = useContext(ProjectContext);
    const theme = useTheme();
    const { projectId } = useParams();

    const [ focus, setFocus ] = useState<TaskFocus>('late');
    const user = useCurrentUser();

    return (
        <Box>
            <ProjectsOverview />

            <Title
                // theme={theme}
                sx={{
                    marginTop: '32px',
                    marginBottom: '24px'
                }} size='xs'>Tasks in Progress</Title>
            <PillTabs
                value={focus}
                // theme={theme}
                aria-label="tasks tabs">
                <PillTab
                    // theme={theme}
                    value='late'
                    iconPosition='start'
                    icon={<Ico_Timed color='primary' />}
                    label="Running Late"
                    onClick={() => setFocus('late')} />
                <PillTab
                    // theme={theme}
                    value='on-schedule'
                    label="On Schedule"
                    iconPosition='start'
                    icon={<Ico_Correct color='primary' />}
                    onClick={() => setFocus('on-schedule')} />
            </PillTabs>

            <ProjectTaskGrid statusFilter='in-progress' all focus={focus} project={project} showUser/>
        </Box>
    );
}

export default OverviewTasks;